var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c(
      "div",
      { staticClass: "wrap" },
      [
        _c(
          "div",
          { staticClass: "wrap-body" },
          [
            _c(
              "transition",
              {
                attrs: { name: "fade" },
                on: {
                  "after-enter": _vm.afterEnterHandler,
                  "after-leave": _vm.afterLeaveHandler
                }
              },
              [_c("router-view", { key: _vm.$route.fullPath })],
              1
            ),
            _vm._v(" "),
            _c("app-menu")
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wrap-footer" }, [_c("app-footer")], 1),
        _vm._v(" "),
        _c("popup-accordion"),
        _vm._v(" "),
        _c("popup-external-link"),
        _vm._v(" "),
        _c("back-to-top")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c948e0fa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c948e0fa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/App.vue
// module id = 557
// module chunks = 0